import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import SchindlerLogo from '../../assets/images/schindler.png';
import { Headline } from '../../elements';
import styles from './Header.module.scss';

const cx = classNames.bind(styles);

const Header = (props) => {
	return (
		<header className={cx(styles.wrapper, { withoutSpace: props.withoutSpace })}>
			<div className={styles.title}>
				<Headline variant='h2'>Digital Media Services</Headline>
				<Headline variant='h3' color='#706f6f'>
					Konfigurator
				</Headline>
			</div>
			<img className={styles.logo} src={SchindlerLogo} alt='Schindler' />
		</header>
	);
};


Header.propTypes = {
    withoutSpace: PropTypes.bool,
}

export default Header;
